import React from 'react';

import { focusIcon } from '@atlaskit/logo/raw-icons';

/** Decorative product icon accompanying the localized Focus attribution name. */
export const FocusAttributionIcon = (): React.JSX.Element => (
	<img src={focusIcon} alt="" width={16} height={16} />
);
